import React, { useState } from "react";
import MyProject from "./../../Data/Projects.json";
import Project from "./Project";
import "./Allprojects.css";
import Fade from "react-reveal/Fade";

const Allprojects = () => {
  const [projects, setProjects] = useState(MyProject);
  // console.log(projects);

  return (
    <div className="main py-3 px-3">
      <div className="container pt-5">
        <h2 className="text-center project">Some of my works</h2>
        <hr style={{ color: "white" }} />
        <Fade top>
          <div className="row p-2">
            {projects.map((project) => (
              <Project project={project} key={project.id}></Project>
            ))}
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default Allprojects;
